import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
const placeholders = defineMessages({
    askAnything: {
        defaultMessage: 'Ask anything…',
        description: 'Default placeholder text for the main ask input field',
        id: 'e8321de9f8',
    },
    typeAt: {
        defaultMessage: 'Type @ for connectors',
        description: 'Placeholder hint for the @ connector typeahead',
        id: '0566e47525',
    },
    typeSlash: {
        defaultMessage: 'Type / for search modes',
        description: 'Placeholder hint for / search modes',
        id: '972284177d',
    },
});
export function useAskInputPlaceholder({ override, showSearchModes = true, showSources = true, } = {}) {
    const intl = useIntl();
    return useMemo(() => {
        if (override) {
            return override;
        }
        const items = [intl.formatMessage(placeholders.askAnything)];
        if (showSources) {
            items.push(intl.formatMessage(placeholders.typeAt));
        }
        if (showSearchModes) {
            items.push(intl.formatMessage(placeholders.typeSlash));
        }
        return items;
    }, [intl, override, showSearchModes, showSources]);
}
//# sourceMappingURL=useAskInputPlaceholder.js.map